import React from "react";
import "./EmptyState.css";

function EmptyState({ icon: Icon, eyebrow, title, lede, action }) {
    return (
        <div className="empty-state">
            <div className="empty-state__corners" aria-hidden="true">
                <span className="empty-state__corner empty-state__corner--tl" />
                <span className="empty-state__corner empty-state__corner--tr" />
                <span className="empty-state__corner empty-state__corner--bl" />
                <span className="empty-state__corner empty-state__corner--br" />
            </div>
            <div className="empty-state__inner">
                {Icon && (
                    <div className="empty-state__icon" aria-hidden="true">
                        <Icon size={20} />
                    </div>
                )}
                {eyebrow && (
                    <div className="empty-state__eyebrow uppercase-label">{eyebrow}</div>
                )}
                {title && <h2 className="empty-state__title">{title}</h2>}
                {lede && <p className="empty-state__lede">{lede}</p>}
                {action && <div className="empty-state__action">{action}</div>}
            </div>
        </div>
    );
}

export default EmptyState;
